import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { useCurrentSociety } from '../../../hooks/useCurrentSociety'
import { QuestionsAndAnswersSection } from './QuestionsAndAnswersSection'
import { faqQueries } from '../../../api/faqs'

export const QuestionsAndAnswers = (): React.ReactNode => {
  const { society } = useCurrentSociety()
  const { data } = useQuery(faqQueries.getFaqsPerSociety(society?._id))

  return (
    <div className="w-full">
      {data?.map((item) => (
        <QuestionsAndAnswersSection key={item._id} section={item} />
      ))}
    </div>
  )
}
